import moment from 'moment';
import 'moment-timezone';
import { ExchangeTransaction } from 'src/redux/modules/exchangeTransaction';
//This is not supported in IE
/* const english_ordinal_rules = new Intl.PluralRules('en', { type: 'ordinal' });
const suffixes = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
};
export function ordinal(number: number) {
  const suffix = suffixes[english_ordinal_rules.select(number)];
  return number + suffix;
}
*/
/**
 * @param date - number
 * @return string
 * will take in a date and return the date with an appropriate suffix
 */
export function ordinal(day) {
  switch (day) {
    case 1:
      return '1st';
    case 2:
      return '2nd';
    case 3:
      return '3rd';
    case 21:
      return '21st';
    case 22:
      return '22nd';
    case 23:
      return '23rd';
    case 31:
      return '31st';
    default:
      return day + 'th';
  }
}

export const endOfMonth = () => {
  const date = moment()
    .subtract(1, 'month')
    .endOf('month')
    .format('MM/DD/YYYY');
  if (date === 'Invalid date') {
    return '12/31/2018';
  }
  return date;
};

export const endOfQuarter = () => {
  const date = moment()
    .subtract(1, 'quarter')
    .endOf('quarter')
    .format('MM/DD/YYYY');
  if (date === 'Invalid date') {
    return '12/31/2018';
  }
  return date;
};

export const contributionCutOff = (value: string) => {
  const date = moment(value);
  return date;
};

/** This function replaces the dash in date with slash and concatenates with Year.
 * e.g: 2-13 and returns 2/13/2018
 * @param {string} value
 * @return date
 */
export const formatDateWithDashToSlash = (value: string) => {
  const date = value.replace('-', '/');
  const year = moment().format('YYYY');
  return `${date}/${year}`;
};

/** This function formats the Unix Date to eliminate timestamp and display with slashes
 * e.g: 2023-12-29T23:59:59.999+0.00 and returns 12/29/23
 * @param {string} value
 * @return date
 */
export const formatUnixWithSlash = (value: string) => {
  const slashOnly = value.replace('-', '/');
  const date = slashOnly.substring(0, slashOnly.indexOf('T'));
  const formattedDate = moment(date).format('M/D/YY');
  return `${formattedDate}`;
};

export const formatUnixDate = (timestamp, format = 'MM/DD/YYYY') => {
  const d = moment(timestamp);
  return d.tz('America/New_York').format(format);
};

export const calculateAndFormatUnixDates = (timestamp, format = 'MM/DD') => {
  const d = moment(timestamp);
  return d.tz('America/New_York').format(format);
};

export const futureDate = (timestamp, addValue) => {
  return moment(timestamp).add(addValue, 'day');
};

export const formatUTCDate = (time, format = 'MM/DD') => {
  if (!time) {
    return undefined;
  }
  return moment.utc(time).format(format);
};

export const getCurrentDate = () => {
  const d = moment();
  return d.tz('America/New_York');
};

export const getCurrentYear = (format) => {
  return getCurrentDate().format(format);
};
export const futureYear = (addValue, format) => {
  return moment().add(addValue, 'year').format(format);
};
export const previousYear = (value, format) => {
  return moment().subtract(value, 'year').format(format);
};

/**
 * @param time - number
 * @return string
 * will take in a number parse it to minutes and seconds and return as string
 */
export const secondsToClock = (time) => {
  const minutes = Math.floor(time / 60);
  const zeroPaddedSeconds = time % 60 < 10 ? '0' + (time % 60) : time % 60;
  return `${minutes}:${zeroPaddedSeconds}`;
};

/**
 * @param month
 * @return string
 * will take in a short month name and return the full month name
 */
export function getMonthName(month) {
  switch (month) {
    case 'JAN':
      return 'January';
    case 'FEB':
      return 'February';
    case 'MAR':
      return 'March';
    case 'APR':
      return 'April';
    case 'MAY':
      return 'May';
    case 'JUN':
      return 'June';
    case 'JUL':
      return 'July';
    case 'AUG':
      return 'August';
    case 'SEP':
      return 'September';
    case 'OCT':
      return 'October';
    case 'NOV':
      return 'November';
    case 'DEC':
      return 'December';
    case 0:
      return 'Jan';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Apr';
    case 4:
      return 'May';
    case 5:
      return 'Jun';
    case 6:
      return 'Jul';
    case 7:
      return 'Aug';
    case 8:
      return 'Sep';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dec';
    default:
      return '';
  }
}

/**
 * will take in a short month name or index and return the short month name
 * @param month
 * @return string
 */
export const getShortMonthName = (month: string) =>
  getMonthName(month).replace(/(\w\w\w).*/, '$1');

type GetFrequencyString = (
  dm: Pick<ExchangeTransaction, 'selectedDays' | 'selectedMonths'>
) => string;

export const getDateFrequencyString: GetFrequencyString = ({
  selectedDays,
  selectedMonths,
}) => {
  const months =
    selectedMonths?.length === 12
      ? 'month'
      : selectedMonths
          .sort((a, b) => a.value - b.value)
          .map(({ label }) => getMonthName(label))
          .join(', ')
          .replace(/(,)([^,]*)$/, ' &$2'); // finds last ',' in the string

  const days = selectedDays
    ?.sort((a, b) => a.value - b.value)
    .map((day) => ordinal(Number(day.label)))
    .join(', ')
    .replace(/(,)([^,]*)$/, ' &$2'); // finds last ',' in the string

  return `Every ${months} on the ${days}`;
};
